import withStyles from "react-jss"
import colors from "../../assets/colors"
import { MAX_WIDTH } from "../../data/globalStyles"

const styles = {
  container: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: MAX_WIDTH,
    background: colors.black,
    color: colors.white,
    margin: "0 auto",
    padding: "0 16px",
  },
  contributors: {
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    padding: "16px",
    margin: "32px 0 16px 0",
    // textTransform: "uppercase",
    borderBottom: "1px solid #D1D1D1",
    "& > :last-child": {
      margin: 0,
    },
  },
  contributor: {
    fontSize: "12px",
    fontWeight: 300,
    letterSpacing: "-0.02em",
    margin: "0 0 8px 0",
    textAlign: "center",
  },
  notes: {
    boxSizing: "border-box",
    width: "100%",
    padding: "0 12px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    margin: "0 0 16px 0",
  },
  text: {
    fontFamily: "ProximaNova",
    fontSize: "14px",
    color: "#999999",
    lineHeight: "16px",
    letterSpacing: "-0.02em",
    margin: "0 0 16px 0",
  },
  creditTitle: {
    display: "block",
    marginRight: "16px",
    fontFamily: "WiredMono",
    textTransform: "uppercase",
    fontWeight: 700,
  },
  creditText: { display: "block", marginRight: "16px", fontWeight: 700 },
}

const Footer = ({ classes }) => {
  return (
    <footer className={classes.container}>
      <div className={classes.contributors}>
        <p className={classes.contributor}>
          <span className={classes.creditTitle}>Writing and Reporting</span>
          <span className={classes.text}>
            Eva Constantaras, Gabriel Geiger, Justin-Casimir Braun, Dhruv
            Mehrotra, Htet Aung
          </span>
        </p>
        <p className={classes.contributor}>
          <span className={classes.creditTitle}>Design and Illustration</span>{" "}
          <span className={classes.text}>
            Kyle Thomas, Alyssa Walker, Katherine Lam
          </span>
        </p>
        <p className={classes.contributor}>
          <span className={classes.creditTitle}>Development</span>
          <span className={classes.text}>
            Raagul Nagendran, Hari Moorthy, Ishita Tiwari, Danielle Carrick,
            Lily Boyce
          </span>
        </p>
        <p className={classes.contributor}>
          <span className={classes.creditTitle}>Editing</span>
          <span className={classes.text}>
            Andrew Couts, James Temperton, Daniel Howden, Tom Simonite
          </span>
        </p>
        <p className={classes.contributor}>
          <span className={classes.creditTitle}>Special Thanks</span>
          <p className={classes.text}>
            Thanks to Margaret Mitchell (Hugging Face), Alexandra Chouldechova
            (Carnegie Mellon University), Cynthia Liem (Technical University of
            Delft), Jann Spiess (Stanford University), Chris Snijders (Technical
            University of Delft), Nicholas Diakopoulos (Northwestern
            University), Nripsuta Saxena (University of California), and Nicolas
            Kayser-Bril (Algorithm Watch) for reviewing our experimental design
            and methodology.
          </p>
          <p className={classes.text}>
            <i>
              Reporting was supported by the Pulitzer Center’s AI Accountability
              Network and the Eyebeam Center for the Future of Journalism.
            </i>
          </p>
        </p>
      </div>
    </footer>
  )
}

export default withStyles(styles)(Footer)
